<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    positionX: {
      type: String,
      required: false,
      default: "left"
    },
    positionY: {
      type: String,
      required: false,
      default: "top"
    }
  }
};
</script>

<template>
  <transition name="zoom" mode="in-out">
    <div v-show="visible" :class="`floating-warning ${positionX} ${positionY}`">
      <div class="title" v-html="title"></div>
      <div class="message" v-html="message"></div>
    </div>
  </transition>
</template>

<style scoped>
.floating-warning {
  max-width: calc(100vw - 60px);
  position: fixed;
  background: var(--pink);
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  z-index: 999;
  display: none;
  flex-direction: column;
  box-shadow: var(--shadow);
}

.title {
  font-size: 16px;
  margin-bottom: 5px;
}

.message {
  font-size: 14px;
}

.left {
  left: 10px;
}

.right {
  right: 10px;
}

.top {
  top: 10px;
}

.bottom {
  bottom: 10px;
}

.center {
  left: 66px;
  right: 66px;
}

@media (max-width: 768px) {
  .floating-warning {
    display: flex;
  }
}

@media (max-width: 480px) {
  .center {
    left: 26px;
    right: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/FloatingWarning.vue